export abstract class BaseStore {
  isLoading = $state(false);
  error = $state<string | null>(null);

  protected async executeWithLoading<T>(
    operation: () => Promise<T>,
    errorMessage?: string
  ): Promise<T | null> {
    this.isLoading = true;
    this.error = null;

    try {
      return await operation();
    } catch (error) {
      this.error =
        error instanceof Error
          ? error.message
          : errorMessage || "An error occurred";
      console.error(this.error, error);
      return null;
    }
  }

  clearError() {
    this.error = null;
  }
}
